export default __webpack_public_path__ + "static/media/CropBtn.4c0cd9c0.svg";